<template>
  <div>
    <v-autocomplete
      v-model="selected"
      :filter="filter"
      @change="$emit('change', selectedCountry)"
      @input="$emit('input', $event)"
      :items="countries"
      v-bind="$attrs"
      item-value="code"
    >
      <template #item="slotProps">
        {{ slotProps.item.name }} ({{ slotProps.item.native_name }})
      </template>
      <template #selection="slotProps">
        {{ slotProps.item.name }} ({{ slotProps.item.native_name }})
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
const defaultCountries = [
  {
    name: "Estonia",
    native_name: "Eesti",
    country_code: "EE",
  },
  {
    name: "Finland",
    native_name: "Suomi",
    country_code: "FI",
  },
  {
    name: "Latvia",
    native_name: "Latvija",
    country_code: "LV",
  },
];
export default {
  props: {
    value: {
      type: String,
      default: "EE",
    },
  },
  mounted() {
    this.fetchCountries();
  },

  data() {
    return {
      selected: "EE",
      countries: defaultCountries,
      loading: false,
    };
  },
  computed: {
    selectedCountry() {
      return this.countries.filter(item => item.code === this.selected);
    },
  },

  methods: {
    filter(item, queryText, itemText) {
      const textOne = item.name.toLowerCase();
      const textTwo = item.native_name.toLowerCase();
      const searchText = queryText.toLowerCase();

      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    },
    async fetchCountries() {
      this.loading = true;
      try {
        const response = await this.axios({
          method: "get",
          url: "api/countries",
          baseURL: "/",
        });

        this.countries = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss"></style>
